/**
 * Grammar-Transformed Patterns (Consolidated)
 *
 * Patterns for SOV/VSO grammar-transformed output.
 * Currently all languages rely on auto-generation from profiles.
 *
 * Phase 3.2: Consolidated from 4 files into single file.
 */

import type { LanguagePattern } from '../types';

/**
 * Get grammar-transformed patterns for a specific language.
 */
export function getGrammarTransformedPatternsForLanguage(language: string): LanguagePattern[] {
  // All languages currently rely on auto-generated patterns
  void language;
  return [];
}
